import Request from './request';

export default class SubscriptionPlanService {
  /**
   * GET /api/admin/subscription-plans/matrix
   * Returns 3-column pricing matrix: plans, prices, grouped entitlements.
   */
  static async getMatrix(currency = 'USD') {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'admin/subscription-plans/matrix',
        query: { currency }
      })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Get subscription matrix error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to fetch pricing matrix' }]
          });
        });
    });
  }

  /**
   * PUT /api/admin/subscription-plans/matrix
   * Atomically saves all plan prices + entitlement mappings.
   * @param {Object} payload - { currency, prices, entitlements }
   */
  static async saveMatrix(payload) {
    return new Promise((resolve) => {
      Request.send({
        method: 'PUT',
        path: 'admin/subscription-plans/matrix',
        data: payload
      })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Save subscription matrix error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to save pricing matrix' }]
          });
        });
    });
  }
}
